export class GetShipments {
  public static readonly type = "[Shipments] Get Shipments";
  public constructor() {}
}
